export const update = (state, payload) => (payload);
